module.exports = __webpack_public_path__ + "static/media/latha.138b09f3.jpeg";